import React from "react";
import { createSearchParams } from "react-router-dom";
import { NavButton } from "./NavButton.tsx";

interface GoToWhatsOnButtonProps {
  venues: string[];
  isButtonDisabled: boolean;
}

export const WhatsOnButton = ({
  venues,
  isButtonDisabled,
}: GoToWhatsOnButtonProps) => {
  const search =
    venues.length > 0
      ? `?${createSearchParams({ cinemas: venues }).toString()}`
      : "";

  return (
    <NavButton
      label={"View Showtimes"}
      ariaLabel={"view showtimes"}
      to={{ pathname: "/films-showing", search }}
      disabled={isButtonDisabled}
      boxSx={{ pb: { xs: 1, md: 3 }, mb: 2 }}
    />
  );
};
